<template>
  <a-modal
          title="污染物字典"
          okText="确认"
          cancelText="取消"
          width="1000px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="CAS码" prop="cas">
            <a-input v-model="formState.cas"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="中文通用名称" prop="cn">
            <a-input v-model="formState.cn"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="英文通用名称" prop="en">
            <a-input v-model="formState.en"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="类别" prop="type">
            <a-input v-model="formState.type"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="用途" prop="useFor">
            <a-input v-model="formState.useFor"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="残留物中文名称" prop="canliuCn">
            <a-input v-model="formState.canliuCn"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="残留物英文名称" prop="canliuEn">
            <a-input v-model="formState.canliuEn"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="污染物性质" prop="level">
            <a-ext-local-dic-select dic-key="BadXingZhi" v-model="formState.level"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="分子式" prop="fenzishi">
            <a-ext-upload v-model="formState.fenzishi"></a-ext-upload>
          </a-form-model-item>
        </a-col>
      </a-row>

    </a-form-model>

  </a-modal>
</template>

<script>

import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect'
import AExtUpload from '../../../components/AntDesignExt/All/AExtUpload'
import {addorUpdateStdBadDic as saveApi,getStdBadDicById as initApi} from '../../../api/api'
import {FormRules} from 'antd-form-rules';
export default {
    name: "FormModel",
    components:{
        AExtLocalDicSelect,AExtUpload,},
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        param:{
            type:Object,
            default: ()=>{
                return {}
            }
        }
    },
    data() {
        return {
            confirmLoading: false,
            formState: {
                cas:'',
                cn:'',
                en:'',
                type:'',
                use_for:'',
                canliu_cn:'',
                canliu_en:'',
                level:'',
                fenzishi:'',
            },
            rules: {
                cas: FormRules.withName('CAS码').string(1, 50).isRequired().create(),
                cn: FormRules.withName('中文通用名称').string(1, 50).isRequired().create(),
                fenzishi:FormRules.withName('上传附件').callback((value, field) => {
                    if (!value.name) {
                        return new Error('必须上传附件');
                    }
                }).isRequired().create(),
            },

        };
    },
    created(){
        this.initForm();
    },
    methods: {
        initForm(){
            if(this.param.id) {
                this.confirmLoading = true;
                initApi(this.param).then((result => {
                    this.formState = result.data.data;
                    this.confirmLoading = false;
                })).catch(() => {
                    this.confirmLoading = false;
                });
            }
        },
        handleOk(e) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    saveApi(this.formState).then((result=>{
                        this.confirmLoading = false;
                        this.$emit("addStdBadDicModalClose",true)
                        this.$emit("update:visible",false)
                    })).catch(()=>{
                        this.confirmLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.$emit("update:visible",false)
        },

    },
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body{
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>